/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import { Dropdown, Modal, Select, DatePicker, message, Button } from "antd";
import {
  CaretDownFilled,
  CaretDownOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import DeleteIcon from "../../../src/assets/delete-icon.png";
import tableIcons from "../../utils/tableIcons";
import BulkDeleteIcon from "../../../src/assets/deletebulk.png";
import dayjs from "dayjs";
import {
  BulkDeleteClient,
  DeleteClient,
  GetClients,
  UpdateClient,
} from "../../utils/api";
import { useNavigate } from "react-router-dom";
import { commonDateFormat } from "../../utils/helper";
// import Loader from "../../components/shared/Loader";

const Clients = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [modalData, setModalData] = useState({
    visible: false,
    selectedStatus: null,
    user: null,
    id: null,
    action: null,
  });
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 25,
    search: "",
    orderField: "",
    orderDirection: "",
    customFilter: "",
  });
  const [bulkSelected, setBulkSelected] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSelectChange = (option) => {
    if (option !== "") {
      setStartDate(null);
      setEndDate(null);
    }
    setQuery((prev) => ({
      ...prev,
      customFilter: option,
      page: 0,
      pageSize: 25,
    }));
  };

  const onRangeChange = (dates) => {
    if (dates === null) {
      setEndDate(null);
      setStartDate(null);
      tableRef.current.onQueryChange();
    }
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("YYYY-MM-DD");
      const endDate = dates[1].format("YYYY-MM-DD");
      if (startDate) {
        setStartDate(startDate);
      }
      if (endDate) {
        setEndDate(endDate);
      }
      tableRef.current.onQueryChange(null);
    }
  };

  const items = [
    {
      label: "Active",
      key: "active",
    },
    // {
    //     label: 'Inactive',
    //     key: 'inactive',
    // },
    {
      label: "Block",
      key: "blocked",
    },
  ];

  const columns = [
    { title: "Id", field: "id", cellStyle: { width: "10%" }, sorting: true },
    {
      title: "Name",
      field: "name",
      cellStyle: { width: "20%" },
      sorting: true,
      render: (record) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => navigate("/admin/clients/" + record?.id)}
          >
            {record.name}
          </span>
        );
      },
    },
    {
      title: "Email",
      field: "email",
      cellStyle: { width: "20%" },
      sorting: true,
    },
    {
      title: "Phone",
      field: "phone_number",
      cellStyle: { width: "15%" },
      sorting: false,
      render: (record) => {
        return <span>+44 {record.phone_number}</span>;
      },
    },
    // {
    //   title: "Reviews",
    //   field: "review_count",
    //   cellStyle: { width: "10%" },
    //   sorting: false,
    //   render: (record) => {
    //     return <span>{record.review_count}</span>;
    //   },
    // },
    {
      title: "Bookings",
      field: "clientBookingCount",
      cellStyle: { width: "10%" },
      sorting: false,
      render: (record) => {
        return <span>{record.clientBookingCount}</span>;
      },
    },
    {
      title: "Created On",
      field: "created_At",
      cellStyle: { width: "14%" },
      sorting: false,
      render: (record) => {
        return <span>{commonDateFormat(record?.created_at)}</span>;
      },
    },
    // {
    //     title: "Location", field: 'location', cellStyle: { width: '20%' }, sorting: false, render: (record) => {
    //         return (
    //             <span>{record.location || '--'}</span>
    //         )
    //     }
    // },
    {
      title: "Status",
      field: "statusType",
      align: "right",
      cellStyle: { width: "10%" },
      sorting: false,
      render: (record) => {
        let updatedItems = items.filter((item) => {
          return item.key !== record.statusType;
        });
        if (record.statusType === "blocked") {
          updatedItems = [
            {
              key: "unblocked",
              label: "Unblock",
            },
          ];
        }
        if (record.statusType === "active") {
          updatedItems = [
            // {
            //     label: 'Inactive',
            //     key: 'inactive',
            // },
            {
              label: "Block",
              key: "blocked",
            },
          ];
        }
        if (record.statusType === "inactive") {
          updatedItems = [
            {
              label: "Active",
              key: "active",
            },
            {
              label: "Block",
              key: "blocked",
            },
          ];
        }
        return (
          <div className="cursor-pointer">
            <Dropdown
              menu={{
                items: updatedItems,
                onClick: (e) =>
                  handleActionModalOpen("changeStatus", e?.key, record),
              }}
              trigger={["click"]}
            >
              <div className="flex items-center justify-end gap-x-1">
                <span
                  className={`capitalize ${
                    record.statusType === "active"
                      ? "text-[green]"
                      : record.statusType === "inactive"
                      ? "text-orange"
                      : record.statusType === "blocked"
                      ? "text-[red]"
                      : "text-black-900"
                  }`}
                >
                  {record.statusType}
                </span>
                <button className="text-[10px]">
                  <CaretDownFilled />
                </button>
              </div>
            </Dropdown>
          </div>
        );
      },
    },
    {
      title: "Action",
      sorting: false,
      render: (record) => {
        return (
          <span
            className="client-delete-icon cursor-pointer flex items-center justify-center"
            onClick={() => handleActionModalOpen("delete", "deleted", record)}
          >
            <img alt="show-icon" src={DeleteIcon} width={16} />
          </span>
        );
      },
    },
  ];

  const fetchData = async (dataquery) => {
    setLoading(true);

    let params = "";
    params += `pageNo=${dataquery?.page + 1}`;
    params += `&limit=${dataquery?.pageSize}`;

    if (dataquery?.search) {
      params += `&search=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
    }

    if (query?.customFilter === "") {
      if (startDate && endDate) {
        params += `&filter=custom`;
        params += `&startDate=${startDate}`;
        params += `&endDate=${endDate}`;
      } else {
        params += `&filter=`;
      }
    } else {
      params += `&filter=${query.customFilter}`;
    }

    const response = await GetClients(params);

    setLoading(false);

    return {
      data: response?.items,
      page: dataquery?.page,
      totalCount: response?.totalRecords,
    };
  };

  const handleActionModalOpen = (action, status, data) => {
    if (action === "delete") {
      setModalData({
        visible: true,
        user: data.name,
        id: data.id,
        selectedStatus: status,
        action: "delete",
      });
    } else if (action === "changeStatus") {
      setModalData({
        visible: true,
        user: data.name,
        selectedStatus: status,
        id: data.id,
        action: "changeStatus",
      });
    } else if (action === "bulkDelete") {
      setModalData({
        visible: true,
        user: data,
        selectedStatus: null,
        id: null,
        action: "bulkDelete",
      });
    }
  };

  const handleChangeStatusOk = async () => {
    if (modalData.action === "changeStatus") {
      try {
        setBtnLoading(true);
        const res = await UpdateClient(
          {
            statusType:
              modalData?.selectedStatus === "unblocked"
                ? "active"
                : modalData?.selectedStatus,
          },
          modalData?.id
        );
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Client status updated successfully");
          setModalData({
            selectedStatus: null,
            user: null,
            id: null,
            visible: false,
            action: null,
          });
          tableRef.current.onQueryChange();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in updating status, Try again later");
      }
    }
  };

  const handleDeleteOk = async () => {
    if (modalData.action === "delete") {
      try {
        setBtnLoading(true);
        const res = await DeleteClient(
          { statusType: modalData?.selectedStatus },
          modalData?.id
        );
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Client Deleted successfully");
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          if (
            tableRef.current?.state?.query?.page + 1 ===
            tableRef.current?.state?.query?.totalCount
          ) {
            setQuery((prev) => ({ ...prev, page: prev.page - 1 }));
            tableRef.current.onQueryChange({ ...query, page: query.page - 1 });
          }
          tableRef.current.onQueryChange();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    }
  };

  const handleBulkDeleteOk = async () => {
    if (modalData.action === "bulkDelete") {
      try {
        setBtnLoading(true);
        const res = await BulkDeleteClient({
          userIds: bulkSelected.map((item) => item?.id.toString()),
        });
        if (res?.isSuccess) {
          setBtnLoading(false);
          message.success("Clients Deleted successfully");
          setBulkSelected([]);
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          if (
            tableRef.current?.state?.query?.page + 1 ===
            tableRef.current?.state?.query?.totalCount
          ) {
            setQuery((prev) => ({ ...prev, page: prev.page - 1 }));
            tableRef.current.onQueryChange({ ...query, page: query.page - 1 });
          }
          tableRef.current.onQueryChange();
        } else {
          message.error(res?.error);
          setBtnLoading(false);
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    }
  };

  const handleModalCancel = () => {
    setModalData({
      visible: false,
      selectedStatus: null,
      user: null,
      id: null,
      action: null,
    });
  };

  useEffect(() => {
    tableRef.current.onQueryChange(query);
  }, [query.customFilter, startDate, endDate]);

  // useEffect(() => {
  //     if (
  //         tableRef.current?.state?.query?.page + 1 ===
  //         tableRef.current?.state?.query?.totalCount
  //     ) {
  //         setQuery((prev) => ({ ...prev, page: prev.page - 1 }));
  //     }
  //     tableRef.current.onQueryChange(query);
  // }, [query.page, tableRef]);

  const overlayContainer = {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Clients Header */}
        <div className="w-full py-4">
          <h2 className="font-semibold text-lg title text-[#000000]">
            Clients
          </h2>
        </div>

        {/* Clients */}
        <div className="search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] h-[380px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl relative">
          <div className="absolute flex items-center justify-end gap-x-2 z-50 right-4 top-5">
            {query.customFilter === "" && bulkSelected?.length === 0 && (
              <RangePicker
                onChange={onRangeChange}
                format="D MMM YY"
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
              />
            )}
            {bulkSelected?.length === 0 ? (
              <Select
                suffixIcon={<CaretDownOutlined />}
                className={`w-32 ${loading && "opacity-50"}`}
                value={query.customFilter}
                onChange={handleSelectChange}
              >
                <Select.Option value="today">Today</Select.Option>
                <Select.Option value="thisWeek">This Week</Select.Option>
                <Select.Option value="lastMonth">Last Month</Select.Option>
                <Select.Option value="quarter">This Quarter</Select.Option>
                <Select.Option value="thisYear">This Year</Select.Option>
                <Select.Option value="">Custom</Select.Option>
              </Select>
            ) : (
              <div
                className="cursor-pointer"
                onClick={() =>
                  handleActionModalOpen("bulkDelete", null, bulkSelected)
                }
              >
                <img src={BulkDeleteIcon} width={22} alt="bulk-delete" />
              </div>
            )}
          </div>

          <MaterialTable
            title="Clients"
            tableRef={tableRef}
            columns={columns}
            icons={tableIcons}
            page={query.page}
            options={{
              selection: true,
              showTitle: false,
              draggable: false,
              paging: true,
              sorting: true,
              search: bulkSelected?.length > 0 ? false : true,
              pageSize: Number(query.pageSize),
              pageSizeOptions: [10, 25, 50, 100],
              debounceInterval: 700,
              padding: "dense",
              paginationType: "stepped",
              searchFieldVariant: "outlined",
              searchFieldAlignment: "left",
            }}
            // Customized empty data component
            // localization={{
            //     body: {
            //         emptyDataSourceMessage: "No records to display",
            //     },
            // }}
            onSelectionChange={(rows) => setBulkSelected(rows)}
            data={(query) => fetchData(query)}
            onChangeRowsPerPage={(pageSize) => {
              setQuery((prev) => ({ ...prev, pageSize: Number(pageSize) }));
            }}
            onChangePage={(page) =>
              setQuery((prev) => ({ ...prev, page: Number(page) }))
            }
            components={{
              Pagination: (props) => {
                const {
                  page,
                  rowsPerPage,
                  count,
                  onChangePage,
                  onChangeRowsPerPage,
                } = props;
                return (
                  <div
                    className="box-shadow-pagination text-sm"
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 20px",
                      marginTop: "20px",
                    }}
                  >
                    <div className="bottom-pagination-text">
                      <button
                        className="disabled:opacity-50"
                        onClick={(e) => {
                          onChangePage(e, page - 1);
                          setBulkSelected([]);
                        }}
                        disabled={page === 0 || bulkSelected?.length > 0}
                      >
                        <LeftOutlined />
                      </button>
                      <span style={{ margin: "0 10px" }}>
                        {page + 1} of {Math.ceil(count / rowsPerPage)}
                      </span>
                      <button
                        className="disabled:opacity-50"
                        onClick={(e) => {
                          onChangePage(e, page + 1);
                          setBulkSelected([]);
                        }}
                        disabled={
                          page === Math.ceil(count / rowsPerPage) - 1 ||
                          tableRef.current?.dataManager?.data?.length === 0 ||
                          bulkSelected?.length > 0
                        }
                      >
                        <RightOutlined />
                      </button>
                    </div>
                    <div style={{ position: "absolute", right: "25px" }}>
                      <span style={{ margin: "0 10px" }}>Items per page:</span>
                      <select
                        className="pagination-select"
                        disabled={
                          tableRef.current?.dataManager?.data?.length === 0 ||
                          bulkSelected?.length > 0
                        }
                        value={rowsPerPage}
                        onChange={(e) => {
                          setBulkSelected([]);
                          onChangeRowsPerPage(e, e.target.value);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>
                );
              },
              OverlayLoading: (props) => {
                return <div style={overlayContainer}>{/* <Loader /> */}</div>;
              },
            }}
          />

          <Modal
            centered
            title={
              modalData.action === "delete"
                ? "Confirm Delete"
                : modalData?.action === "changeStatus"
                ? "Confirm Status Change"
                : "Confirm Selection Delete"
            }
            open={modalData.visible}
            onCancel={handleModalCancel}
            footer={
              <div>
                <Button onClick={handleModalCancel}>Cancel</Button>
                <Button
                  type="primary"
                  className="text-white"
                  onClick={
                    modalData.action === "delete"
                      ? handleDeleteOk
                      : modalData.action === "changeStatus"
                      ? handleChangeStatusOk
                      : handleBulkDeleteOk
                  }
                >
                  Ok
                  {btnLoading && (
                    <span className="loader ml-2 align-middle mb-1"></span>
                  )}
                </Button>
              </div>
            }
          >
            {modalData.action === "changeStatus"
              ? `Are you sure you want to change the status of ${modalData.user} to ${modalData.selectedStatus}?`
              : modalData.action === "delete"
              ? `Are you sure you want to delete ${modalData.user}?`
              : "Are you sure you want to delete the selected clients?"}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default withDashboardLayout(Clients);
